exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\n\n/* For Tracenow Product */\n\n\n.flex-direction-nav a {\n    margin-right: 73% !important;\n}\n\n\n.img_size{\n    width: 312px !important;\n    height: 548px !important;\n}\n\n\n/* End Tracenow product  */", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/Projects/Veepal/Veepal.Com/Dev/node_modules/css-loader?{"sourceMap":false,"import":false}!D:/Projects/Veepal/Veepal.Com/Dev/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!D:/Projects/Veepal/Veepal.Com/Dev/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles